import React, { useContext } from "react";
import { Issue } from "@adsk/acc-issues-types";
import { ReportConfirmationModal } from "../../utils/components/ReportConfirmationModal";
import { BcfModal } from "@adsk/acc-issues-list";
import { IssuesAdditionalOptionsMenu } from "@adsk/acc-issues-common/components/display/IssuesAdditionalOptionsMenu";
import { DeletedIssuesSpaceContext } from "@adsk/acc-issues-core/providers/DeletedIssuesSpaceContext";
import { IssuesAdditionalOptionsMenuType } from "@adsk/acc-issues-common/types/exports";

export const IssueDetailTabActionsDropdown = ({ issue }: { issue: Issue }) => {
  const [exportType, setExportType] =
    React.useState<IssuesAdditionalOptionsMenuType | undefined>(undefined);

  const isDeletedIssuesSpaceActive = useContext(DeletedIssuesSpaceContext);

  const exportTypes: IssuesAdditionalOptionsMenuType[] = [
    IssuesAdditionalOptionsMenuType.EXPORT_AS_PDF,
  ];
  if (!isDeletedIssuesSpaceActive) {
    exportTypes.push(IssuesAdditionalOptionsMenuType.EXPORT_AS_BCF);
  }
  return (
    <div
      style={{
        position: "absolute",
        right: 16,
        width: 36,
        marginTop: 3,
        textAlign: "right",
        overflow: "visible",
      }}
    >
      <IssuesAdditionalOptionsMenu
        menuItemTypes={exportTypes}
        onClick={setExportType}
        isSingleIssueExport={true}
      />
      <ReportConfirmationModal
        isOpen={exportType === IssuesAdditionalOptionsMenuType.EXPORT_AS_PDF}
        issue={issue}
        closeReportModal={() => setExportType(undefined)}
      />
      {exportTypes.includes(IssuesAdditionalOptionsMenuType.EXPORT_AS_BCF) && (
        <BcfModal
          isSingleExport={true}
          isOpen={exportType === IssuesAdditionalOptionsMenuType.EXPORT_AS_BCF}
          issue={issue}
          closeReportModal={() => setExportType(undefined)}
          exportParams={{ id: issue.id }}
        />
      )}
    </div>
  );
};
